var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.962 5.163a.6.6 0 0 1 0 1.2H4.728A1.48 1.48 0 0 0 3.249 7.84V19.27a1.48 1.48 0 0 0 1.479 1.478h11.428a1.48 1.48 0 0 0 1.479-1.479v-6.233a.6.6 0 0 1 1.199 0v6.234a2.68 2.68 0 0 1-2.678 2.677H4.728A2.68 2.68 0 0 1 2.05 19.27V7.84a2.68 2.68 0 0 1 2.678-2.677zm10.39-3.116q.058 0 .115.01.04.01.077.024l.035.01a1 1 0 0 1 .082.044l.022.01a.6.6 0 0 1 .167.168q.011.02.021.04.02.032.034.065.008.023.015.047a.6.6 0 0 1 .031.181v6.235a.6.6 0 0 1-1.2 0V4.095L10.346 14.5a.6.6 0 0 1-.848-.849L19.903 3.246h-4.786a.6.6 0 0 1 0-1.2z"
  })));
};
export default SvgExternalLink;